<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; width: 100%; height: 50vh;">
  <img style="width: 200px;" src="../../../assets/logo-prody.gif" alt="">
</div>